import * as React from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";

export default function StandardImageList() {
  return (
    <ImageList sx={{ width: 300, height: 1000 }} cols={2} rowHeight={164}>
      {itemData.map((item) => (
        <ImageListItem key={item.img}>
          <img
            src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
            srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
            alt={item.title}
            loading="lazy"
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
}

const itemData = [
  {
    img: "https://lh3.googleusercontent.com/pw/AL9nZEUXYedHwk73RLiFrmkpZk9GoY0Fa54teTfnJC1MYdYz6RaIJHT6asSGH3b_effaXZyLHlq7aoN6SknGa71fKZsukK7cTaSs7-vSDAXkoIlDW8NzIgM2PNjMZyQnQl9G4yBZZNb_Ek8KSRG_62U3oZAeAg=w1080-h1079-no?authuser=0",
  },
  {
    img: "https://lh3.googleusercontent.com/pw/AL9nZEXVIWAHtnvf7QhLhKaaUhyPb1iX4vpGRTGdVK48VOTtQE6bBEF_0FAuATbnczt2AK--0Ma4L3-CzmfB0kV0G33_NSnMJ9iuQBqffnLbL2jMHNHwKoNp6Xa48mqqGSEVN9FFlDil_uhtuEujFySCzZBJCA=w1092-h1359-no?authuser=0",
  },
  {
    img: "https://lh3.googleusercontent.com/pw/AL9nZEWbpl4dF-L4kuyoTdxtBwF3iDkl1yOME3krihL1VlxqJVd3Gdi_edXOjrFdgegPa_Lxe-6kM8eUW07p5zwqac9KDJRY-7nQS5789RcIwoF8F2CI6yuB9azD3YoKCvWDxnzglGkQcUrd7xdcyMPAlEyUyA=w1088-h1359-no?authuser=0",
  },
  {
    img: "https://lh3.googleusercontent.com/pw/AL9nZEWEAirTbMZkdWZ5h7q5Zmsp_ZsWXFJ8mUQw-0Ap7JTT3214zjesOZNBlxxEV7vkfdu7UaTninVFDGaUJEMooENsi1kBvS1Ord1mapWPRW3CAjahvgifld_P3vUchcxV1Vx0E6uXWS4ztDO1DvA8w99qSQ=w1088-h1359-no?authuser=0",
  },
  {
    img: "https://lh3.googleusercontent.com/pw/AL9nZEWglmSkfdKc895zzXmZQVrFmMpGN264FrjlyTYUHhbRuwMoYVtwq-lQIUgFGfEgHK2iMaLhlJY96AW4o2pU00rYQzKnTiYspkDvj3qo-99ZS5NRt7cR5RK1E9awgM0jSb9UIhtQVetyGedkudHTEwWAcw=w1092-h1359-no?authuser=0",
  },
  {
    img: "https://lh3.googleusercontent.com/pw/AL9nZEVXpwDztnFEG6dKovRGAy4jC6DP6CUjrx4cIpi5GWReoQEPeMVrXYGzxGES6Bg_N71opkU3Qhf7h26_03oKxGnwKsnmF6JDyoSWib8SK0RoaduO_1Po6-6E3V_H_J6H6paZyoLjUppjmc9Gz7yOzto8QA=w1092-h1359-no?authuser=0",
  },
  {
    img: "https://lh3.googleusercontent.com/pw/AL9nZEXnYOfIlceuOSh-DBBnxkKjI-xCtuNfTqHIYFgDFNNMYwCuv2hQFjSHrwL5P7biF1nqLxcSY4uBDIgOgwZiHgIq_obGlhRg6br8hXISr2maH9gTlEJPhTH7JXyvjGBOBxBA33kTf5oUDloeJSZkZXHSpA=w1088-h1359-no?authuser=0",
  },
  {
    img: "https://lh3.googleusercontent.com/pw/AL9nZEXLyxRFKcqk2D5W-6wCjJGBoh1oN1DLz2WixGkEDvQ9KSsYBDyuWmILpykGVBYdtHYe7LbT7N6GGP_cLjVQVKQ86Cp-H_d3d_DRgEamfEHoDGIZxoXvrS0PmrozeJ6F9f8bDkEENKVumMpMKbjiNNeQQw=w1092-h1359-no?authuser=0",
  },
  {
    img: "https://lh3.googleusercontent.com/pw/AL9nZEXnLUOO_eH1Ap0MH-hTO4QTuNbvHiEJbiglZrEc3pCii_vXuICAxEzaC_YZim5pSLtIQVJf-EL2GXpEXuTPNvk65WXy7BrnNx7qAPuUflukAETDANAK-RZf6iqqpNQMqFjF1qpJzIHIgYgl7YImvHA1BA=w1088-h1359-no?authuser=0",
  },
  {
    img: "https://lh3.googleusercontent.com/pw/AL9nZEV-dKYVa4gfPolHL-6LdgExrhoYNQuQsqkaclzRdExf-5E1B-uOXH7n6B4g85yP3qtmtdOYzDbwBOcei0hzCpIIIrAANcEgWAjCJBy9b_CLmSuvEPj0qFl5i0WLtiXImIdIJyl5sbS0ByEVo5qDX6WlvA=w1092-h1359-no?authuser=0",
  },
  {
    img: "https://lh3.googleusercontent.com/pw/AL9nZEUZwRXm5yqU2GgSez2QwriOu6NJ4xFivu_LzD96S5PYzUSK0lLHMSqsqtKqG318bmCyp7bbGoJmbAi5SDjVOtyUtI_S6pzLvlJjEBgSPHxXBl7XRqiVzfozPRwjx8IPU5dMGsVPKN2L7YZpxW2i-xULkQ=w1092-h1359-no?authuser=0",
  },
];
